import { render, staticRenderFns } from "./ModalWidgetAdd.vue?vue&type=template&id=47b6e468&scoped=true&lang=pug"
import script from "./ModalWidgetAdd.vue?vue&type=script&lang=js"
export * from "./ModalWidgetAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalWidgetAdd.vue?vue&type=style&index=0&id=47b6e468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6e468",
  null
  
)

export default component.exports